import { frontendURL } from '../../../helper/URLHelper';
import CatalogImovelShow from './pages/CatalogImovelShow.vue';
import ImoveisIndex from './pages/ImoveisIndex.vue';
import ImovelDuplicateCandidates from './pages/ImovelDuplicateCandidates.vue';
import ListingImportOperations from './pages/ListingImportOperations.vue';
import PortalIntegrationsConsole from './pages/PortalIntegrationsConsole.vue';
import PortalSyncOperations from './pages/PortalSyncOperations.vue';
import ImovelShow from './pages/ImovelShow.vue';
import ImovelForm from './pages/ImovelForm.vue';
import { LAIS_IMOVEIS_PERMISSIONS } from '../laisRouteHelpers';

const meta = { permissions: LAIS_IMOVEIS_PERMISSIONS };
const adminMeta = { permissions: ['administrator'] };

export const routes = [
  {
    path: frontendURL('accounts/:accountId/imoveis'),
    alias: [
      frontendURL('accounts/:accountId/properties'),
      frontendURL('accounts/:accountId/property'),
      frontendURL('accounts/:accountId/empreendimentos'),
    ],
    name: 'imoveis_index',
    component: ImoveisIndex,
    meta,
  },
  {
    path: frontendURL('accounts/:accountId/imoveis/new'),
    name: 'imovel_new',
    component: ImovelForm,
    meta,
  },
  {
    path: frontendURL('accounts/:accountId/imoveis/importacoes'),
    alias: [
      frontendURL('accounts/:accountId/properties/imports'),
      frontendURL('accounts/:accountId/imoveis/imports'),
    ],
    name: 'imoveis_import_operations',
    component: ListingImportOperations,
    meta,
  },
  {
    path: frontendURL('accounts/:accountId/imoveis/portais'),
    alias: [
      frontendURL('accounts/:accountId/properties/portals'),
      frontendURL('accounts/:accountId/imoveis/portal-syncs'),
    ],
    name: 'imoveis_portal_sync_operations',
    component: PortalSyncOperations,
    meta,
  },
  {
    path: frontendURL(
      'accounts/:accountId/imoveis/portais/configuracao/:portal?'
    ),
    alias: [
      frontendURL('accounts/:accountId/properties/portals/config/:portal?'),
      frontendURL('accounts/:accountId/imoveis/portal-integrations/:portal?'),
    ],
    name: 'imoveis_portal_integrations_console',
    component: PortalIntegrationsConsole,
    meta,
  },
  {
    path: frontendURL('accounts/:accountId/imoveis/duplicidades'),
    alias: [frontendURL('accounts/:accountId/properties/duplicates')],
    name: 'imoveis_duplicate_candidates',
    component: ImovelDuplicateCandidates,
    meta: adminMeta,
  },
  {
    path: frontendURL('accounts/:accountId/imoveis/catalog/:catalog/:id'),
    alias: [
      frontendURL('accounts/:accountId/empreendimentos/catalog/:catalog/:id'),
    ],
    name: 'imovel_catalog_show',
    component: CatalogImovelShow,
    meta,
  },
  {
    path: frontendURL(
      'accounts/:accountId/imoveis/catalog/:catalog/:id/:section'
    ),
    alias: [
      frontendURL(
        'accounts/:accountId/empreendimentos/catalog/:catalog/:id/:section'
      ),
    ],
    name: 'imovel_catalog_section',
    component: CatalogImovelShow,
    meta,
  },
  {
    path: frontendURL('accounts/:accountId/imoveis/:id'),
    alias: [
      frontendURL('accounts/:accountId/properties/:id'),
      frontendURL('accounts/:accountId/property/:id'),
    ],
    name: 'imovel_show',
    component: ImovelShow,
    meta,
  },
  {
    path: frontendURL('accounts/:accountId/imoveis/:id/edit'),
    name: 'imovel_edit',
    component: ImovelForm,
    meta,
  },
  {
    path: frontendURL('accounts/:accountId/imoveis/:id/:section'),
    alias: [
      frontendURL('accounts/:accountId/properties/:id/:section'),
      frontendURL('accounts/:accountId/property/:id/:section'),
      frontendURL('accounts/:accountId/imovel/:id/:section'),
    ],
    name: 'imovel_show_section',
    component: ImovelShow,
    meta,
  },
];
